<article class="license-card">
  <div class="license-card-head">
    <div class="license-card-title-block">
      <h3>{{ product?.name || 'Unnamed Product' }}</h3>
      <span class="product-id" *ngIf="product?.id">ID: {{ product?.id }}</span>
    </div>

    <div class="license-card-actions" *ngIf="showActions">
      <button
        class="icon-action-btn edit-btn"
        type="button"
        aria-label="Edit licensed product"
        (click)="onEdit()"
      >
        <mat-icon class="outlined-icon">edit</mat-icon>
      </button>

      <button
        class="icon-action-btn delete-btn"
        type="button"
        aria-label="Delete licensed product"
        (click)="onDelete()"
      >
        <mat-icon class="outlined-icon">delete</mat-icon>
      </button>
    </div>
  </div>

  <p class="description">
    {{ product?.description || 'No description provided.' }}
  </p>

  <div class="component-list">
    <span class="component-chip"
      >Target: {{ product?.target || 'DEVICE' }}</span
    >
  </div>

  <div class="component-list">
    <span
      class="component-chip"
      *ngFor="let component of product?.licensedComponents || []"
    >
      {{ getComponentName(component) }}
    </span>
    <span
      class="component-chip component-chip-empty"
      *ngIf="(product?.licensedComponents || []).length === 0"
    >
      No licensed components
    </span>
  </div>
</article>
